import { render, staticRenderFns } from "./editPage.vue?vue&type=template&id=58e9459a&"
import script from "./editPage.vue?vue&type=script&lang=js&"
export * from "./editPage.vue?vue&type=script&lang=js&"
import style0 from "./editPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports